/**
 * Tabs the manifest declares but this build does not draw yet. Each names the
 * spec that builds it, so a declared tab is a plan a person can read, never
 * an error and never a blank viewport (cvce-pipeline-1 spec, same contract as
 * CVCE Marketing's KET-6498 build-time corrections). `accuracy_findings` and
 * `listings` were built by cvce-pipeline-2/3 and no longer belong here.
 */
export const COMING_NEXT: Record<string, string> = {};

export function ComingNext({ tabKey }: { tabKey: string }) {
  const line = COMING_NEXT[tabKey] ?? "This tab comes in a later CVCE Pipeline module build.";
  return (
    <div className="flex flex-col gap-1 py-6">
      <p className="text-base font-semibold text-ks-ink">Coming next</p>
      <p className="text-sm text-ks-ink">{line}</p>
    </div>
  );
}
